<template>
  <div class="synapse">
    <div>
      <HeaderBar3 :preferred="preferred" :loading="loading" :showSections="true" @setSection_in="setSection_out($event)" :ref="hbref"></HeaderBar3>
    </div>
    <div v-if="section != null && sections.includes(section)">
      <!-- Probes Section-->
      <div v-if="section == 'probes' && sections.includes('probes')" class="p-2" style="margin-top: 92px;">
        <Probes :key="compkeys.probes"></Probes>
      </div>
      <!-- Monitoring Section-->
      <div v-if="section == 'monitoring' && sections.includes('monitoring')" class="p-2" style="margin-top: 92px;">
        <Monitoring :key="compkeys.monitoring"></Monitoring>
      </div>
      <!-- Events Section-->
      <div v-if="section == 'events' && sections.includes('events')" class="p-2" style="margin-top: 92px;">
        <Events :key="compkeys.events"></Events>
      </div>
      <!-- Underwork Section-->
      <div v-if="section == 'underwork' && sections.includes('underwork')" class="p-2" style="margin-top: 92px;">
        <div class="fs-1 fw-light" style="margin-top: 18%;" >
          <i class="fa-solid fa-xl fa-cog fa-spin text-warning"></i>
          <div class="fa-fade text-warning">
            Currently under work.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderBar3 from '@/components/HeaderBar3.vue'
import Probes from '@/components/apps-components/synapse/Probes.vue'
import Monitoring from '@/components/apps-components/synapse/Monitoring.vue'
import Events from '@/components/apps-components/synapse/Events.vue'

import axios from "axios";

export default {
  name: 'Suite',
  components: {
    HeaderBar3,
    Probes,
    Monitoring,
    Events
  },
  data(){
    return {
      site: null,
      service_mode: null, // PV | PB
      stage: null,        // D  | P
      customer: null,     // Solve
      loading: false,
      // View
      view: 'synapse',
      hbref: 'hb_synapse',
      section: null,
      preferred: 'monitoring',
      sections: [],
      apps: {},
      // Components keys.
      compkeys: {
        probes: 0,
        monitoring: 0,
        events: 0
      }
    }
  },
  methods:{
    solve(){
      this.loading = true
      const params = {view: this.view}
      const dest = this.site + '/suite/main/dnsuite'
      axios
          .get(dest, {params})
          .then(rx => {
            this.customer = rx.data.customer
            this.username = rx.data.username
            this.apps     = rx.data.apps
            this.sections = rx.data.sections
            this.$refs[this.hbref].init(this.view, this.username, this.customer, this.sections, this.apps)
            this.loading = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            //this.processErrorMessage(error)
          });
    },
    setSection_out(entry){
      this.section = entry
    }
  },
  created: function(){
    this.stage = process.env.NODE_ENV
    this.service_mode = process.env.VUE_APP_SERVICE_MODE
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    this.solve()
  }
}
</script>

<style scoped>
  .synapse{
    overflow: auto;
  }
</style>
